module.exports = __webpack_public_path__ + "static/media/EntDetailsScreen_elRules_219862.f9dbb39b.jpg";